import { AppCatRadioProps } from './AppCatRadio.types';
import __isEmpty from 'lodash/isEmpty';
import styles from './appcatradio.module.scss';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
// @ts-ignore
import { useViewport } from 'hooks/corporatiu/useViewport';
import clsx from 'clsx';

const AppCatRadio = (props: Readonly<AppCatRadioProps>) => {
    const { seccio, item } = props;
    const { isMobile } = useViewport();

    const stylesHero = clsx({
        [styles.hero]: true,
        [styles.isMobile]: isMobile
    });

    if (!item) return null;

    switch (seccio) {
        case 'cap':
            return <div className={stylesHero}></div>;
        case 'text':
            return (
                <article className={styles.appCatRadio}>
                    <Titol titol={item.titol} tag='h1' estil='titolPagina' />

                    <p>{item.disponible}</p>

                    {!__isEmpty(item.aplicacions) &&
                        item.aplicacions?.map((app, index) => (
                            <div key={index} className={styles.markets}>
                                <Enllac href={app.links[0].url} title={app.links[0].nom}>
                                    <Imatge
                                        src={'https://statics.3cat.cat/recursos/ccma/apple-app-store.svg'}
                                        loading='lazy'
                                        width={88}
                                        height={26}
                                        alt={`${app.nom} ${app.links[0].nom}`}
                                        aria-hidden='true'
                                    />
                                </Enllac>
                                <Enllac href={app.links[1].url} title={app.links[1].nom}>
                                    <Imatge
                                        src={'https://statics.3cat.cat/recursos/ccma/google-play.svg'}
                                        loading='lazy'
                                        width={100}
                                        height={26}
                                        alt={`${app.nom} ${app.links[1].nom}`}
                                        aria-hidden='true'
                                    />
                                </Enllac>
                            </div>
                        ))}

                    <Text text={item.descarrega} tag='div' className='gapAfter' />
                    <Text text={item.condicions} tag='div' className='gapAfter' />
                    <Text text={item.ajuda} tag='div' className='gapAfter' />
                </article>
            );
    }
};

export default AppCatRadio;
